/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import { TotalPrice, EffectivePrice } from "./PriceTree";
import { DiscountInformation } from "./DiscountInformation";

export interface StrikePrice {
  showPercentage: boolean;
  /** the total strike price */
  total: number;
  /** the strike price difference */
  difference: number;
  /** the percentage of the difference */
  percentage: number;
}

export interface PriceDifference {
  isDecreased: boolean;
  amount: number;
  text: string;
}

export interface PriceInfo {
  /** the total price */
  total: number;
  /** the per person price */
  person: number;
  /**
   * the effective price, use the effectivePrice instead
   *
   * @deprecated
   */
  effective: number;
  /**
   * the included "or" voucher amount in effective price, use the effectivePrice instead
   *
   * @deprecated
   */
  effectiveWithVoucher: number;
  /**
   * the child discount value, the child discount value, isn't used anymore, see PRPOR-46951
   *
   * @deprecated
   */
  childDiscount: PriceInfo_ChildDiscount;
  /** the strike price data */
  strike?: StrikePrice;
  difference?: PriceDifference;
  /**
   * use effectivePrice and price tree structure instead
   *
   * @deprecated
   */
  totalPrice?: TotalPrice;
  /**
   * should be removed, since price tree will be used from S3 on
   *
   * @deprecated
   */
  discountInformation?: DiscountInformation;
  effectivePrice?: EffectivePrice;
}

export enum PriceInfo_ChildDiscount {
  /** None - no child discount */
  None = "None",
  /** Inclusive - child discount already calculated */
  Inclusive = "Inclusive",
  /** Expected - child discount expected (not already calculated) */
  Expected = "Expected",
}

export function priceInfo_ChildDiscountFromJSON(
  object: any
): PriceInfo_ChildDiscount {
  switch (object) {
    case 0:
    case "None":
      return PriceInfo_ChildDiscount.None;
    case 1:
    case "Inclusive":
      return PriceInfo_ChildDiscount.Inclusive;
    case 2:
    case "Expected":
      return PriceInfo_ChildDiscount.Expected;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum PriceInfo_ChildDiscount"
      );
  }
}

export function priceInfo_ChildDiscountToJSON(
  object: PriceInfo_ChildDiscount
): string {
  switch (object) {
    case PriceInfo_ChildDiscount.None:
      return "None";
    case PriceInfo_ChildDiscount.Inclusive:
      return "Inclusive";
    case PriceInfo_ChildDiscount.Expected:
      return "Expected";
    default:
      return "UNKNOWN";
  }
}

export function priceInfo_ChildDiscountToNumber(
  object: PriceInfo_ChildDiscount
): number {
  switch (object) {
    case PriceInfo_ChildDiscount.None:
      return 0;
    case PriceInfo_ChildDiscount.Inclusive:
      return 1;
    case PriceInfo_ChildDiscount.Expected:
      return 2;
    default:
      return 0;
  }
}

function createBaseStrikePrice(): StrikePrice {
  return { showPercentage: false, total: 0, difference: 0, percentage: 0 };
}

export const StrikePrice = {
  encode(
    message: StrikePrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.showPercentage === true) {
      writer.uint32(32).bool(message.showPercentage);
    }
    if (message.total !== 0) {
      writer.uint32(13).float(message.total);
    }
    if (message.difference !== 0) {
      writer.uint32(21).float(message.difference);
    }
    if (message.percentage !== 0) {
      writer.uint32(29).float(message.percentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StrikePrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStrikePrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.showPercentage = reader.bool();
          break;
        case 1:
          message.total = reader.float();
          break;
        case 2:
          message.difference = reader.float();
          break;
        case 3:
          message.percentage = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): StrikePrice {
    return {
      showPercentage: isSet(object.showPercentage)
        ? Boolean(object.showPercentage)
        : false,
      total: isSet(object.total) ? Number(object.total) : 0,
      difference: isSet(object.difference) ? Number(object.difference) : 0,
      percentage: isSet(object.percentage) ? Number(object.percentage) : 0,
    };
  },

  toJSON(message: StrikePrice): unknown {
    const obj: any = {};
    message.showPercentage !== undefined &&
      (obj.showPercentage = message.showPercentage);
    message.total !== undefined && (obj.total = message.total);
    message.difference !== undefined && (obj.difference = message.difference);
    message.percentage !== undefined && (obj.percentage = message.percentage);
    return obj;
  },

  fromPartial(object: DeepPartial<StrikePrice>): StrikePrice {
    const message = createBaseStrikePrice();
    message.showPercentage = object.showPercentage ?? false;
    message.total = object.total ?? 0;
    message.difference = object.difference ?? 0;
    message.percentage = object.percentage ?? 0;
    return message;
  },
};

function createBasePriceDifference(): PriceDifference {
  return { isDecreased: false, amount: 0, text: "" };
}

export const PriceDifference = {
  encode(
    message: PriceDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isDecreased === true) {
      writer.uint32(24).bool(message.isDecreased);
    }
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.isDecreased = reader.bool();
          break;
        case 1:
          message.amount = reader.float();
          break;
        case 2:
          message.text = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceDifference {
    return {
      isDecreased: isSet(object.isDecreased)
        ? Boolean(object.isDecreased)
        : false,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      text: isSet(object.text) ? String(object.text) : "",
    };
  },

  toJSON(message: PriceDifference): unknown {
    const obj: any = {};
    message.isDecreased !== undefined &&
      (obj.isDecreased = message.isDecreased);
    message.amount !== undefined && (obj.amount = message.amount);
    message.text !== undefined && (obj.text = message.text);
    return obj;
  },

  fromPartial(object: DeepPartial<PriceDifference>): PriceDifference {
    const message = createBasePriceDifference();
    message.isDecreased = object.isDecreased ?? false;
    message.amount = object.amount ?? 0;
    message.text = object.text ?? "";
    return message;
  },
};

function createBasePriceInfo(): PriceInfo {
  return {
    total: 0,
    person: 0,
    effective: 0,
    effectiveWithVoucher: 0,
    childDiscount: PriceInfo_ChildDiscount.None,
    strike: undefined,
    difference: undefined,
    totalPrice: undefined,
    discountInformation: undefined,
    effectivePrice: undefined,
  };
}

export const PriceInfo = {
  encode(
    message: PriceInfo,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.total !== 0) {
      writer.uint32(13).float(message.total);
    }
    if (message.person !== 0) {
      writer.uint32(21).float(message.person);
    }
    if (message.effective !== 0) {
      writer.uint32(61).float(message.effective);
    }
    if (message.effectiveWithVoucher !== 0) {
      writer.uint32(77).float(message.effectiveWithVoucher);
    }
    if (message.childDiscount !== PriceInfo_ChildDiscount.None) {
      writer
        .uint32(24)
        .int32(priceInfo_ChildDiscountToNumber(message.childDiscount));
    }
    if (message.strike !== undefined) {
      StrikePrice.encode(message.strike, writer.uint32(34).fork()).ldelim();
    }
    if (message.difference !== undefined) {
      PriceDifference.encode(
        message.difference,
        writer.uint32(42).fork()
      ).ldelim();
    }
    if (message.totalPrice !== undefined) {
      TotalPrice.encode(message.totalPrice, writer.uint32(50).fork()).ldelim();
    }
    if (message.discountInformation !== undefined) {
      DiscountInformation.encode(
        message.discountInformation,
        writer.uint32(66).fork()
      ).ldelim();
    }
    if (message.effectivePrice !== undefined) {
      EffectivePrice.encode(
        message.effectivePrice,
        writer.uint32(82).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceInfo {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.total = reader.float();
          break;
        case 2:
          message.person = reader.float();
          break;
        case 7:
          message.effective = reader.float();
          break;
        case 9:
          message.effectiveWithVoucher = reader.float();
          break;
        case 3:
          message.childDiscount = priceInfo_ChildDiscountFromJSON(
            reader.int32()
          );
          break;
        case 4:
          message.strike = StrikePrice.decode(reader, reader.uint32());
          break;
        case 5:
          message.difference = PriceDifference.decode(reader, reader.uint32());
          break;
        case 6:
          message.totalPrice = TotalPrice.decode(reader, reader.uint32());
          break;
        case 8:
          message.discountInformation = DiscountInformation.decode(
            reader,
            reader.uint32()
          );
          break;
        case 10:
          message.effectivePrice = EffectivePrice.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceInfo {
    return {
      total: isSet(object.total) ? Number(object.total) : 0,
      person: isSet(object.person) ? Number(object.person) : 0,
      effective: isSet(object.effective) ? Number(object.effective) : 0,
      effectiveWithVoucher: isSet(object.effectiveWithVoucher)
        ? Number(object.effectiveWithVoucher)
        : 0,
      childDiscount: isSet(object.childDiscount)
        ? priceInfo_ChildDiscountFromJSON(object.childDiscount)
        : PriceInfo_ChildDiscount.None,
      strike: isSet(object.strike)
        ? StrikePrice.fromJSON(object.strike)
        : undefined,
      difference: isSet(object.difference)
        ? PriceDifference.fromJSON(object.difference)
        : undefined,
      totalPrice: isSet(object.totalPrice)
        ? TotalPrice.fromJSON(object.totalPrice)
        : undefined,
      discountInformation: isSet(object.discountInformation)
        ? DiscountInformation.fromJSON(object.discountInformation)
        : undefined,
      effectivePrice: isSet(object.effectivePrice)
        ? EffectivePrice.fromJSON(object.effectivePrice)
        : undefined,
    };
  },

  toJSON(message: PriceInfo): unknown {
    const obj: any = {};
    message.total !== undefined && (obj.total = message.total);
    message.person !== undefined && (obj.person = message.person);
    message.effective !== undefined && (obj.effective = message.effective);
    message.effectiveWithVoucher !== undefined &&
      (obj.effectiveWithVoucher = message.effectiveWithVoucher);
    message.childDiscount !== undefined &&
      (obj.childDiscount = priceInfo_ChildDiscountToJSON(
        message.childDiscount
      ));
    message.strike !== undefined &&
      (obj.strike = message.strike
        ? StrikePrice.toJSON(message.strike)
        : undefined);
    message.difference !== undefined &&
      (obj.difference = message.difference
        ? PriceDifference.toJSON(message.difference)
        : undefined);
    message.totalPrice !== undefined &&
      (obj.totalPrice = message.totalPrice
        ? TotalPrice.toJSON(message.totalPrice)
        : undefined);
    message.discountInformation !== undefined &&
      (obj.discountInformation = message.discountInformation
        ? DiscountInformation.toJSON(message.discountInformation)
        : undefined);
    message.effectivePrice !== undefined &&
      (obj.effectivePrice = message.effectivePrice
        ? EffectivePrice.toJSON(message.effectivePrice)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<PriceInfo>): PriceInfo {
    const message = createBasePriceInfo();
    message.total = object.total ?? 0;
    message.person = object.person ?? 0;
    message.effective = object.effective ?? 0;
    message.effectiveWithVoucher = object.effectiveWithVoucher ?? 0;
    message.childDiscount =
      object.childDiscount ?? PriceInfo_ChildDiscount.None;
    message.strike =
      object.strike !== undefined && object.strike !== null
        ? StrikePrice.fromPartial(object.strike)
        : undefined;
    message.difference =
      object.difference !== undefined && object.difference !== null
        ? PriceDifference.fromPartial(object.difference)
        : undefined;
    message.totalPrice =
      object.totalPrice !== undefined && object.totalPrice !== null
        ? TotalPrice.fromPartial(object.totalPrice)
        : undefined;
    message.discountInformation =
      object.discountInformation !== undefined &&
      object.discountInformation !== null
        ? DiscountInformation.fromPartial(object.discountInformation)
        : undefined;
    message.effectivePrice =
      object.effectivePrice !== undefined && object.effectivePrice !== null
        ? EffectivePrice.fromPartial(object.effectivePrice)
        : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
